var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 14,
    viewBox: "0 0 41 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6578 13.6514H14.3369L16.4124 0.895891H19.7337L17.6578 13.6514ZM11.5432 0.895891L8.37716 9.66921L8.00252 7.77998L8.00286 7.78066L6.88542 2.04438C6.88542 2.04438 6.75031 0.895891 5.3101 0.895891H0.0760648L0.0146484 1.11187C0.0146484 1.11187 1.61522 1.44488 3.48842 2.56983L6.37362 13.6517H9.83374L15.1172 0.895891H11.5432ZM37.6638 13.6514H40.7132L38.0545 0.89555H35.385C34.1522 0.89555 33.8519 1.84614 33.8519 1.84614L28.8991 13.6514H32.3609L33.0532 11.7567H37.2749L37.6638 13.6514ZM34.0096 9.13932L35.7545 4.36591L36.7361 9.13932H34.0096ZM29.1587 3.96329L29.6326 1.22413C29.6326 1.22413 28.1703 0.667969 26.6458 0.667969C24.9978 0.667969 21.0842 1.38825 21.0842 4.89068C21.0842 8.18601 25.6774 8.22695 25.6774 9.95787C25.6774 11.6888 21.5574 11.3786 20.1977 10.2871L19.704 13.1512C19.704 13.1512 21.1869 13.8715 23.4525 13.8715C25.7187 13.8715 29.1376 12.6981 29.1376 9.50441C29.1376 6.18793 24.503 5.87914 24.503 4.43722C24.5034 2.99496 27.7376 3.18024 29.1587 3.96329Z",
    fill: "#2566AF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIcon);
export default __webpack_public_path__ + "static/media/visa-icon.068c880a648f956c359eece007e7cfed.svg";
export { ForwardRef as ReactComponent };